var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 25.999,
    viewBox: "0 0 20 25.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_TA-plan_blue",
    "data-name": "icon TA-plan blue",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(-2.52 -0.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-1",
    d: "M18.69,19.04H17.21L12.94,1.58a1.645,1.645,0,0,0-3.19.01L5.48,19.04H4a1.477,1.477,0,0,0-1.48,1.48v1.29A1.49,1.49,0,0,0,4,23.29H18.69a1.492,1.492,0,0,0,1.48-1.49V20.51A1.487,1.487,0,0,0,18.69,19.04ZM11.34,2.5l1.6,6.52H9.74ZM18.4,21.52H4.28V20.8H6.22a.75.75,0,0,0,.65-.27,2.255,2.255,0,0,0,.22-.66L8.7,13.31h5.29l1.6,6.52a2.587,2.587,0,0,0,.22.68.807.807,0,0,0,.66.29H18.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaPlan);
export default __webpack_public_path__ + "static/media/ta-plan.8f3ceb96.svg";
export { ForwardRef as ReactComponent };